import * as React from 'react'

// Modal shown before the feedback form is posted. Escape and a click on the
// backdrop both cancel, so the dialog can never trap a delegate mid-form.
const ConfirmDialog = ({ title, message, confirmLabel, cancelLabel, onConfirm, onCancel }) => {
  const confirmRef = React.useRef(null)

  React.useEffect(() => {
    if (confirmRef.current) confirmRef.current.focus()

    const handleKey = (event) => {
      if (event.key === 'Escape') onCancel()
    }

    document.addEventListener('keydown', handleKey)
    return () => document.removeEventListener('keydown', handleKey)
  }, [onCancel])

  return (
    <div className="survey-confirm-backdrop" onMouseDown={onCancel}>
      <div
        className="survey-confirm"
        role="dialog"
        aria-modal="true"
        aria-label={title}
        onMouseDown={(event) => event.stopPropagation()}
      >
        <h3 className="survey-confirm-title">{title}</h3>
        <p className="survey-confirm-message">{message}</p>
        <div className="survey-confirm-actions">
          <button type="button" className="btn confirm-cancel" onClick={onCancel}>
            {cancelLabel}
          </button>
          <button
            type="button"
            className="btn confirm-submit"
            ref={confirmRef}
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  )
}

export default ConfirmDialog
